<template>
  <div>
    <DialogComponent />
    <ToolbarComponent :toolbar-state="'menu'" />
    <div class="contact_us_container">
      <div class="cu">
        Contact us
      </div>
      <div>
        <span class="placeholder">Full Name:</span>
        <input v-model="name" :class="{'validation_error' : nameError}" placeholder="Full Name" class="gotit_input">
      </div>
      <div>
        <span class="placeholder">Email:</span>
        <input v-model="email" :class="{'validation_error' : emailError}" placeholder="Email" class="gotit_input">
      </div>
      <div>
        <span class="placeholder">Title:</span>
        <input v-model="title" :class="{'validation_error' : titleError}" placeholder="Title" class="gotit_input">
      </div>
      <div>
        <span class="placeholder">Message:</span>
        <textarea
          v-model="message"
          rows="3"
          :class="{'validation_error' : messageError}"
          placeholder="Message"
          class="gotit_input message"
        />
      </div>
      <button :disabled="loading || formIsNotValid" class="gotit_button send_message" :class="{'disabled': formIsNotValid}" @click="sendMessage()">
        Send Message
      </button>
      <br>
      <br>
      <div class="cu_details">
        <div class="icon">
          <img v-lazy-load data-src="/place.svg" alt="place icon">
        </div>
        <div class="info">
          <div>3500 s. Dupont Hway</div>
          <div>Dover, Delaware, 19901</div>
        </div>
      </div>
      <div class="cu_details">
        <div class="icon">
          <img v-lazy-load data-src="/alternate_email.svg" alt="gotit email">
        </div>
        <div class="info">
          <div><a href="mailto:info@gotitapp.net">info@gotitapp.net</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolbarComponent from '~/components/ToolbarComponent'
import DialogComponent from '~/components/DialogComponent'
export default {
  components: { ToolbarComponent, DialogComponent },
  data () {
    return {
      name: '',
      nameError: false,
      email: '',
      emailError: false,
      title: '',
      titleError: false,
      message: '',
      messageError: false,
      reg: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.[0-9]{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  head () {
    return {
      title: 'GOTit Social Ecommerce - Support',
      meta: [
        { hid: 'description', name: 'description', content: process.env.gotitDescription },
        { hid: 'application-name', name: 'application-name', content: 'GOTit' },
        {
          hid: 'image',
          name: 'image',
          content: process.env.gotitLogo
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: process.env.gotitLogo
        },
        { hid: 'url', name: 'url', content: 'https://gotitstores.com' },
        { hid: 'og:url', name: 'og:url', content: 'https://gotitstores.com' }
      ]
    }
  },
  computed: {
    formIsNotValid () {
      return !this.name || !this.message || !this.title || !this.reg.test(this.email)
    }
  },
  methods: {
    sendMessage () {
      this.loading = true
      this.$store.dispatch('api/sendComment', {
        text: `${this.email}: Name: ${this.name}\nTitle: ${this.title}\nMessage: ${this.message}`,
        type: 'PRIVATE',
        senderId: this.$store.state.localStorage.currentUser.id,
        objectId: '344535'
      }).then((newComment) => {
        this.loading = true
        this.name = ''
        this.email = ''
        this.title = ''
        this.message = ''
        this.$root.$emit('show_dialog', {
          title: 'We\'ve got your message',
          message: 'Our customer service will get back to you within 24 hours.'
        })
      })
        .catch((_) => {
          this.$root.$emit('show_dialog', {
            title: 'Oops! something went wrong',
            message: 'please try again in a few seconds'
          })
        })
    }
  }
}
</script>

<style scoped>
  .contact_us_container {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    background-color: white;
    padding: 1em;
    margin-top: 4em;
    height: 100vh;
  }
  .mobile_design .contact_us_container {
    max-width: 100%;
  }
  .cu {
    /*font-family: 'HKGroteskBold', serif;*/
    font-weight: bold;
    font-size: 1.2em;
    margin-bottom: 1em;
  }
  .cu_details {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1em;
  }
  .cu_details .icon {
    width: 40px;
   }

  .cu_details .info {
    flex-grow: 1;
  }

  .message {
    height: 7em;
  }

  .send_message {
    margin-top: 1em;
  }
</style>
